import { render, staticRenderFns } from "./EmployeesSettings.vue?vue&type=template&id=9108f2c0"
import script from "./EmployeesSettings.vue?vue&type=script&lang=js"
export * from "./EmployeesSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports